import {
  Box,
  Flex,
  Grid,
  GridItem,
  Text,
} from "@chakra-ui/react";
import React from "react";

const Work = ({ title, subTitle, company, date, children }) => {
  return (
    <Grid
      templateColumns={{
        base: "1fr",
        md: "repeat(5, 1fr)",
        lg: "repeat(6, 1fr)",
      }}
      gap={{ base: 3, md: 5 }}
      alignItems="start"
    >
      <GridItem colSpan={{ base: 1, md: 2, lg: 2 }} textAlign="left">
        <Flex direction="column" gap={3} align="flex-start">
          <Text fontSize={["sm", "md", "lg"]} as="b" color="gray.800">
            {title}
          </Text>
          {subTitle && (
            <Text fontSize={["xs", "sm", "md"]} color="gray.700">
              {subTitle}
            </Text>
          )}
          <Text fontSize={["xs", "sm", "md"]} as="b" color="gray.800">
            {company}
          </Text>
          <Text fontSize={["xs", "sm"]} color="gray.600">
            {date}
          </Text>
        </Flex>
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 3, lg: 4 }}>
        <Box
          fontSize={["xs", "sm", "md"]}
          textAlign={{ base: "left", md: "justify" }}
          color="gray.700"
        >
          {children}
        </Box>
      </GridItem>
    </Grid>
  );
};

export default Work;
